import { BaseField, colSize, selectType } from '@/models/BaseField';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  Self,
  SimpleChanges
} from '@angular/core';
import { ControlValueAccessor, FormControlDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { NgFor, NgIf } from '@angular/common';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ErrorMessageComponent } from '../error-message/error-message.component';

interface selectItem {
  display: string;
  value: any;
  disabled?: false;
}
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    MatOptionModule,
    NgFor,
    TranslateModule,
    ErrorMessageComponent
  ]
})
export class SelectComponent extends BaseField<string, string> implements OnInit, ControlValueAccessor, OnChanges {
  @Input() label = 'label manquant'; // translate key
  @Input() typeI: selectType;
  @Input() size: colSize = 6;
  @Input() list: any[] = [];
  @Input() disabledValues: any[] = [];
  @Input() isDisabled = false;
  @Input() isEnum = false;
  @Input() enumName = '';
  @Input() isMultiple = true;
  @Input() withAllItem = false;
  @Input() withNoneItem = false;
  @Input() useLabelTranslation = true;
  @Input() valueKey = '';
  @Input() displayKey = '';
  @Output() valueChanged = new EventEmitter<any>();

  type: selectType;
  prefixLabel = '';
  itemList: selectItem[] = [];

  constructor(@Self() @Optional() protected override control: FormControlDirective, private el: ElementRef) {
    super(control);
    this.control && (this.control.valueAccessor = this);
  }

  ngOnInit(): void {
    if (this.size > 0) {
      (this.el.nativeElement as HTMLElement).classList.add('col-md-' + this.size);
    }
    this.prefixLabel = this.isEnum ? 'enum.' + this.enumName + '.' : '';

    // performances
    this.list.forEach((l) => {
      const value = this.valueKey ? l[this.valueKey] : l;
      this.itemList.push({
        value: value,
        disabled: this.disabledValues.find((v) => v === value),
        display: this.isEnum && !this.displayKey ? this.prefixLabel + l : this.prefixLabel + l[this.displayKey]
      });
    });
  }

  setValue(value: string): void {}

  onChange(e: any) {
    this.valueChanged.emit(e.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled']) {
      this.setDisabled(this.isDisabled);
    }
  }

  setDisabled(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.control.disable();
    } else {
      this.control.control.enable();
    }
  }
}
